import { useMemo } from "react";

const parseNode = (node, key) => {
    if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return null;

    const children = Array.from(node.childNodes).map((child, i) =>
        parseNode(child, i)
    );

    const tag = node.tagName.toLowerCase();

    switch (tag) {
        case "strong":
        case "b":
            return (
                <strong key={key} className="font-semibold">
                    {children}
                </strong>
            );

        case "a":
            return (
                <a
                    key={key}
                    href={node.getAttribute("href")}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                >
                    {children}
                </a>
            );

        case "ul":
            return (
                <ul key={key} className="list-disc pl-5 space-y-1">
                    {children}
                </ul>
            );

        case "li":
            return <li key={key}>{children}</li>;

        case "p":
            return (
                <p key={key} className="mb-2">
                    {children}
                </p>
            );

        case "table":
            return (
                <table key={key} className="min-w-full border border-collapse">
                    {children}
                </table>
            );

        case "tr":
            return (
                <tr key={key} className="border-b">
                    {children}
                </tr>
            );

        case "td":
            return (
                <td key={key} className="border p-2">
                    {children}
                </td>
            );

        case "figure":
        case "tbody":
            return <div key={key}>{children}</div>;

        case "br":
            return <br key={key} />;

        default:
            return <span key={key}>{children}</span>;
    }
};

export const useParsedContent = (html) => {
    return useMemo(() => {
        if (!html) return null;

        let cleaned = html
            .replace(/__nls__/g, "")
            .replace(/\\"/g, '"')
            .replace(/\\u20b9/g, "₹");

        const parser = new DOMParser();
        const doc = parser.parseFromString(cleaned, "text/html");

        return Array.from(doc.body.childNodes).map((node, i) =>
            parseNode(node, i)
        );
    }, [html]);
};